// Prepend a string value with a hash

function toHex(value) {
  return value ? "#".concat(value) : '';
}
export default toHex;